import React from 'react';
import {
	FaAngleRight,
	FaAngleLeft,
	FaThLarge,
	FaSignOutAlt,
	FaBars,
	FaRegUser,
	FaRegFileAlt,
	FaLayerGroup,
	FaNetworkWired,
	FaClipboardList,
	FaCaretSquareRight
} from 'react-icons/fa';
import { NavLink } from "react-router-dom";
import '../Styles/Navbar.css'

const ICON_SIZE = 12;

function Navbar({ visible, show }) {

	return (
		<>
			<div className="mobile-nav">
				<button
					className="mobile-nav-btn"
					onClick={() => show(!visible)}
				>
					<FaBars size={24} />
				</button>
			</div>
			<nav className={!visible ? 'navbar' : ''}>
				<button
					type="button"
					className="nav-btn"
					onClick={() => show(!visible)}
				>
					{!visible
						? <FaAngleRight size={30} /> : <FaAngleLeft size={30} />}
				</button>
				<div>
					<div className="logo">
						<img
							src={require("../Assets/logo.png")}
							alt="logo"
						/>
					</div>
					<div className="links nav-top">
						<NavLink to="/dashboard" className={({ isActive }) => `nav-link ${isActive ? 'active-link' : ''}`}>
							<FaThLarge size={ICON_SIZE} />
							<span>Dashboard</span>
						</NavLink>
						<NavLink to="/workgroup" className={({ isActive }) => `nav-link ${isActive ? 'active-link' : ''}`}>
							<FaLayerGroup size={ICON_SIZE} />
							<span>Work Group</span>
						</NavLink>
						<NavLink to="/workstation" className={({ isActive }) => `nav-link ${isActive ? 'active-link' : ''}`}>
							<FaNetworkWired size={ICON_SIZE} />
							<span>Work Station</span>
						</NavLink>
						<NavLink to="/employees" className={({ isActive }) => `nav-link ${isActive ? 'active-link' : ''}`}>
							<FaRegUser size={ICON_SIZE} />
							<span>Employees</span>
						</NavLink>
						
						{/* <NavLink to="/report"className={({ isActive }) => `nav-link ${isActive ? 'active-link' : ''}`}>
							<FaRegFileAlt  size={ICON_SIZE} />
							<span>Reports</span>
						</NavLink> */}
						
						<NavLink to="/product" className={({ isActive }) => `nav-link ${isActive ? 'active-link' : ''}`}>
							<FaClipboardList size={ICON_SIZE} />
							<span>Products</span>
						</NavLink>
					</div>
				</div>

				<div className="links">
					<NavLink to="/" className="nav-link">
						<FaSignOutAlt size={ICON_SIZE} />
						<span>Logout</span>
					</NavLink>
				</div>
			</nav>
		</>
	);
}

export default Navbar;
